import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router';
import type { Crumb } from './section-trail';

interface BreadcrumbsProps {
  /** The pages above this one. */
  trail: Crumb[];
  /** This page, shown last and never a link. Left out while it's still loading (a record's name). */
  current?: string;
}

function Separator() {
  return <ChevronRight aria-hidden className="size-3 shrink-0 text-muted" />;
}

function CrumbLabel({ crumb }: { crumb: Crumb }) {
  if (crumb.to) {
    return (
      <Link to={crumb.to} className="truncate text-link hover:underline">
        {crumb.label}
      </Link>
    );
  }
  return <span className="truncate tracking-wide text-muted uppercase">{crumb.label}</span>;
}

/** Where this page sits, so a record or a tab never leaves you guessing. Wraps, and truncates long names, rather than scrolling at 390px. */
export function Breadcrumbs({ trail, current }: BreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb">
      <ol className="flex flex-wrap items-center gap-1 text-xs font-medium">
        {trail.map((crumb, index) => (
          <li key={`${crumb.label}-${index}`} className="flex min-w-0 items-center gap-1">
            {index > 0 && <Separator />}
            <CrumbLabel crumb={crumb} />
          </li>
        ))}
        {current && (
          <li className="flex min-w-0 items-center gap-1">
            {trail.length > 0 && <Separator />}
            <span aria-current="page" className="truncate text-muted">
              {current}
            </span>
          </li>
        )}
      </ol>
    </nav>
  );
}
